<div [ngClass]="classes">
  <ng-content select="[icon]"></ng-content>
</div>